import { postUpdateViewAdmin } from '../api/postUpdateViewAdmin';

const setPostUpdateViewAdmin = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateViewAdmin(params);
            window.location.replace(window.location.pathname);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateViewAdmin
}